import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './component/app/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './component/app/store';
import './polyfill/closest';
import 'custom-event-polyfill';
import 'url-search-params-polyfill';

import packageJson from '../package.json';

const currentVersion = localStorage.getItem('version');
if (currentVersion !== packageJson.version) {
}

window.React = React;
window.ReactDOM = ReactDOM;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
